import api from './client'
import type { BrainSettings } from '@/types/brainSettings'

export function fetchBrainSettings() {
  return api.get<{ data: BrainSettings }>('/brain_setting')
}
